module.exports = __webpack_public_path__ + "img/plus_bgstihuan.80854126.png";